import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=05334e52&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=ts"
export * from "./CreateCard.vue?vue&type=script&lang=ts"
import style0 from "./CreateCard.vue?vue&type=style&index=0&id=05334e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05334e52",
  null
  
)

export default component.exports